import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { callPublicApi } from '../../api';
import './Login.css';

function Login({ onLogin }) {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const [showChangePassword, setShowChangePassword] = useState(false);
    const [newPassword, setNewPassword] = useState('');
    const [tempToken, setTempToken] = useState(null);
    const [tempUser, setTempUser] = useState(null);
    const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    const [turnstileToken, setTurnstileToken] = useState(isLocalhost ? 'localhost-bypass' : null);
    const turnstileRef = useRef(null);
    const widgetIdRef = useRef(null);

    const SITE_KEY = '0x4AAAAAAC0p_WBRl_4ZM0e4';

    useEffect(() => {
        const renderTurnstile = () => {
            if (window.turnstile && turnstileRef.current && !widgetIdRef.current) {
                try {
                    widgetIdRef.current = window.turnstile.render(turnstileRef.current, {
                        sitekey: SITE_KEY,
                        callback: (token) => {
                            console.log("Turnstile Token Received:", token);
                            setTurnstileToken(token);
                        },
                        'expired-callback': () => {
                            console.log("Turnstile Expired");
                            setTurnstileToken(null);
                        },
                        'error-callback': (error) => {
                            console.error("Turnstile Error Details:", error);
                            setTurnstileToken(null);
                        },
                        theme: 'light',
                        language: 'tr',
                    });
                } catch (e) {
                    console.error("Turnstile Render Catch:", e);
                }
            }
        };

        const timer = setInterval(() => {
            if (window.turnstile) {
                renderTurnstile();
                clearInterval(timer);
            }
        }, 1000);

        return () => {
            clearInterval(timer);
        };
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!turnstileToken && !isLocalhost) {
            setError('Lütfen bot doğrulamasını (Turnstile) tamamlayınız.');
            return;
        }
        setError('');
        setLoading(true);

        try {
            const loginBody = { username, password, turnstileToken: isLocalhost ? 'localhost-bypass' : turnstileToken };
            const response = await callPublicApi('/auth/login', 'POST', loginBody);

            if (response && response.token) {
                if (response.mustChangePassword) {
                    setShowChangePassword(true);
                    setTempToken(response.token);
                    setTempUser(response.user);
                    setLoading(false);
                    return;
                }

                // Normal Login
                completeLogin(response.token, response.user);
            } else {
                setError('Giriş başarısız. Lütfen bilgilerinizi kontrol edin.');
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
            setError('Giriş yapılamadı: ' + (err.message || 'Sunucu hatası'));
            setLoading(false);
        }
    };

    const handleChangePassword = async (e) => {
        e.preventDefault();
        if (newPassword.length < 6) {
            setError('Şifre en az 6 karakter olmalıdır.');
            return;
        }

        setLoading(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}auth/change-password`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${tempToken}`
                },
                body: JSON.stringify({ currentPassword: password, newPassword })
            });

            const data = await response.json();

            if (data.success) {
                completeLogin(tempToken, tempUser);
            } else {
                setError(data.error || 'Şifre değiştirilemedi.');
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const completeLogin = (token, user) => {
        localStorage.setItem('authToken', token);
        localStorage.setItem('user', JSON.stringify(user));
        onLogin(user);
        navigate('/');
    };

    if (showChangePassword) {
        return (
            <div className="login-container">
                <div className="login-box">
                    <div className="login-header">
                        <h2>Şifre Belirleme</h2>
                        <p>İlk girişiniz için yeni bir şifre belirleyin.</p>
                    </div>
                    <form onSubmit={handleChangePassword}>
                        <div className="form-group">
                            <label>Yeni Şifre</label>
                            <input
                                type="password"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                placeholder="Yeni şifreniz"
                                required
                            />
                        </div>
                        {error && <div className="error-message">{error}</div>}
                        <button type="submit" disabled={loading} className="login-btn">
                            {loading ? 'Kaydediliyor...' : 'Şifreyi Kaydet ve Gir'}
                        </button>
                    </form>
                </div>
            </div>
        );
    }

    return (
        <div className="login-container">
            <div className="login-box">
                <div className="login-header">
                    <h2>KluGastronomi</h2>
                    <p>Yönetim Paneli Girişi</p>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Kullanıcı Adı</label>
                        <input
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            placeholder="admin"
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>Şifre</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="••••••"
                            required
                        />
                    </div>

                    {!isLocalhost && (
                        <div className="form-group" style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px', minHeight: '65px' }}>
                            <div ref={turnstileRef}></div>
                        </div>
                    )}
                    
                    {isLocalhost && (
                        <div className="form-group" style={{ textAlign: 'center', marginBottom: '12px' }}>
                            <span style={{ fontSize: '0.78rem', color: '#6366f1', background: 'rgba(99,102,241,0.1)', padding: '4px 12px', borderRadius: '20px', fontWeight: '600' }}>
                                🛠️ Yerel Geliştirme Modu — Turnstile Atlandı
                            </span>
                        </div>
                    )}

                    {error && <div className="error-message" style={{ marginBottom: '15px' }}>{error}</div>}

                    <button type="submit" disabled={loading || (!turnstileToken && !isLocalhost)} className="login-btn">
                        {loading ? 'Giriş Yapılıyor...' : 'Giriş Yap'}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default Login;
